/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScanToPaySetDefaultPaymentMethodMutationVariables = Types.Exact<{
  paymentMethodId: Types.Scalars['String']['input'];
}>;

export type ScanToPaySetDefaultPaymentMethodMutation = {
  readonly __typename?: 'Mutation';
  readonly setDefaultPaymentMethod: {
    readonly __typename: 'PaymentProfile';
    readonly id: string;
    readonly defaultCardId: string | null;
  };
};

export const ScanToPaySetDefaultPaymentMethodDocument = gql`
  mutation ScanToPaySetDefaultPaymentMethod($paymentMethodId: String!) {
    setDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
      __typename
      id
      defaultCardId
    }
  }
`;

export function useScanToPaySetDefaultPaymentMethodMutation() {
  return Urql.useMutation<
    ScanToPaySetDefaultPaymentMethodMutation,
    ScanToPaySetDefaultPaymentMethodMutationVariables
  >(ScanToPaySetDefaultPaymentMethodDocument);
}
